import React from 'react';
import {
  Banner, BannerActions, BannerContent, Button
} from '@salt-ds/core';
import {CloseIcon} from '@salt-ds/icons';

function CardAlert(props) {
  // const [open, setOpen] = useState(true);
  const onClose = () => {
    // setOpen(false);
    if (props.setHasError != null) {
      props.setHasError(false)
    }
    if (props.setShowAlertBox != null) {
      props.setShowAlertBox(false);
    }
    if (props.setShowBanner != null) {
      props.setShowBanner(false);
    }
    if (props.setIsAccessCodeButtonClicked != null) {
      props.setIsAccessCodeButtonClicked(false);
    }
    if (props.setIsAnotherAccessCodeButtonClicked != null) {
      props.setIsAnotherAccessCodeButtonClicked(false);
    }
    if(props.setHasError != null) {
      props.setHasError(false);
    }
    if (props.setShowNotification != null) {
      props.setShowNotification(false);
    }
    if (props.setIsSpinnerVisible != null) {
      props.setIsSpinnerVisible(false);
    }
  };
  return (
    <Banner variant="secondary" status={props.status} style={props.style} className={"card-alert"}>
      <BannerContent style={props.contentStyle} role="alert">
        {props.children}
      </BannerContent>
      <BannerActions>
        <Button aria-label="close banner" appearance="transparent" onClick={onClose}>
          <CloseIcon />
        </Button>
      </BannerActions>
    </Banner>
  )
    ;
}

export default CardAlert;